import { FC } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '../../redux/reducers/store';
import AppSplash from '../splash/AppSplash';
import App from './App';

const AppProvider: FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<AppSplash />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
};

export default AppProvider;
